module.exports = __webpack_public_path__ + "static/img/334_TO8_2580_og.aec8a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/334_TO8_2580_og.jpg
// module id = FHNP
// module chunks = 0